export const getSpecialEventName = (game) => {
    const specialEventName = game?.specialEventSeason?.specialEvent?.name;
    const sponsorPrefix = game?.specialEventSeason?.sponsorPrefix || '';
    return specialEventName ? sponsorPrefix + ' ' + specialEventName : '';
};
